import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, OnDestroy, Input } from '@angular/core';
import { Chart } from 'chart.js/auto';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-smart-ctm',
    // standalone: true,
    // imports: [CommonModule],
    templateUrl: './smart-ctm.component.html',
    styleUrl: './smart-ctm.component.scss',
    standalone: false
})
export class SmartCTMComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('unifiedChart', { static: false }) unifiedChartRef!: ElementRef<HTMLCanvasElement>;
  @ViewChild('distributionChart', { static: false }) distributionChartRef!: ElementRef<HTMLCanvasElement>;


 @Input() serial: string = '';

  // Precio por hora de uso (en euros)
  pricePerHour: number = 30;

  // Precio por kWh (en euros)
  priceKwh: number = 0.9;

  ctmData = {
    "name": "Pista 1",
    "serial": "",
    "consumo": 1200,
    "online": true,
    "activo": true,
    "historialAnual": [100, 95, 105, 90, 110, 95, 100, 95, 95, 110, 100, 105],
    "historialMensual": [
      2, 3, 4, 1, 5, 2, 4, 3, 2, 1,
      5, 2, 4, 3, 1, 4, 5, 2, 3, 1,
      5, 2, 4, 3, 2, 1, 4, 5, 2, 3
    ],
    "activoPorDia": [
      60, 90, 45, 120, 75,
      80, 100, 50, 95, 110,
      85, 70, 65, 90, 120,
      55, 100, 95, 60, 80,
      90, 110, 75, 85, 95,
      100, 60, 120, 90, 70
    ],
    "tiempoActivo": 2660,
    "activoAnual": [2660, 2400, 2500, 2450, 2550, 2600, 2700, 2500, 2480, 2620, 2580, 2650]
  };

  distributionChartInstance: any;

  // Propiedades para los gráficos alternables
  currentChartType: 'hourly' | 'users' = 'hourly';
  chartTitle = 'Distribución horaria';

  // Nueva propiedad para alternar entre consumo y tiempo
  chartViewType: 'monthly' | 'total' = 'monthly';
  monthlyChartType: 'consumption' | 'time' = 'consumption';
  totalChartType: 'consumption' | 'time' = 'consumption';

  // Propiedades para el gráfico unificado
  private totalChart: any = null;
  private distributionChart: any = null;
  private unifiedChart: any = null;

  // Propiedades para el período y tipo de datos del gráfico unificado
  chartPeriodType: 'monthly' | 'annual' = 'monthly';
  chartDataType: 'consumption' | 'time' = 'consumption';

  // Colores unificados para los gráficos
  private readonly ENERGY_COLORS = {
    background: 'rgba(54, 162, 235, 0.8)',
    border: '#36a2eb'
  };

  private readonly TIME_COLORS = {
    background: 'rgba(255, 159, 64, 0.8)',  // Naranja para tiempo
    border: '#ff9f40'
  };

  // Colores para el gráfico de usuarios
  userColors = ['#ff6384', '#36a2eb', '#4bc0c0', '#ffcd56', '#ff9f40'];

  // Datos para el gráfico de barras diario del mes
  chartData = {
    labels: Array.from({length: 31}, (_, i) => (i + 1).toString()),
    datasets: [{
      label: 'Consumo diario (kWh)',
      data: [
        185, 220, 195, 240, 210, 175, 160, 245, 235, 190,
        205, 225, 180, 265, 250, 195, 215, 230, 185, 200,
        245, 210, 175, 190, 255, 240, 195, 220, 205, 185, 200
      ],
      backgroundColor: 'rgba(100, 116, 139, 0.8)',
      borderColor: '#64748b',
      borderWidth: 1,
      type: 'bar' as const
    }, {
      label: 'Media',
      data: Array(31).fill(213), // Media calculada de los datos
      borderColor: '#ff6384',
      backgroundColor: 'rgba(255, 99, 132, 0.1)',
      borderWidth: 2,
      type: 'line' as const,
      fill: false,
      pointRadius: 0,
      pointHoverRadius: 4,
      borderDash: [5, 5]
    }]
  };

  // Datos de usuarios para la tabla
  usersData = [
    { name: 'Juan Pérez', id: '1ad32', time: 10.5, consumption: 18.5, cost: 315.00 },
    { name: 'María García', id: '2ada2', time: 9.0, consumption: 16.2, cost: 270.00 },
    { name: 'Carlos López', id: '3a000', time: 8.3, consumption: 14.8, cost: 249.00 },
    { name: 'Ana Martín', id: '4a28d', time: 7.5, consumption: 13.1, cost: 225.00 },
    { name: 'Luis Rodríguez', id: '55632', time: 9.0, consumption: 12.4, cost: 270.00 }
  ];

  // Datos para el gráfico circular de distribución horaria
  distributionData = {
    labels: ['Punta', 'Llano', 'Valle'],
    datasets: [{
      data: [25, 45, 30],
      backgroundColor: ['#ff6384', '#36a2eb', '#4bc0c0'],
      borderWidth: 2,
      borderColor: '#fff'
    }]
  };

  // Datos para el gráfico de usuarios
  usersChartData = {
    labels: this.usersData.map(user => user.name),
    datasets: [{
      data: this.usersData.map(user => user.consumption),
      backgroundColor: this.userColors.slice(0, this.usersData.length),
      borderWidth: 2,
      borderColor: '#fff'
    }]
  };

  ngOnInit() {


    console.log('serial del CTM ' , this.serial);
    // Inicialización del componente
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.initUnifiedChart();
      this.initDistributionChart();
    }, 100);
  }

  ngOnDestroy() {
    if (this.unifiedChart) {
      this.unifiedChart.destroy();
    }
    if (this.distributionChart) {
      this.distributionChart.destroy();
    }
  }

  getChartTitle(): string {
    const viewText = this.chartViewType === 'monthly' ? 'Mensual' : 'Acumulado';
    const dataText = this.chartDataType === 'consumption' ? 'Consumo' : 'Tiempo';
    return `${dataText} ${viewText}`;
  }

  switchChartDataType(type: 'consumption' | 'time') {
    this.chartDataType = type;
    this.updateUnifiedChart();
  }

  switchChartViewType(type: 'monthly' | 'total') {
    this.chartViewType = type;
    this.updateUnifiedChart();
  }

  private updateUsersChartData() {
    this.usersChartData.labels = this.usersData.map(user => user.name);
    this.usersChartData.datasets[0].data = this.usersData.map(user => user.consumption);
    this.usersChartData.datasets[0].backgroundColor = this.userColors.slice(0, this.usersData.length);
  }

  switchChart(type: 'hourly' | 'users') {
    this.currentChartType = type;
    this.chartTitle = type === 'hourly' ? 'Distribución horaria' : 'Consumo por usuario';
    this.updateDistributionChart();
  }

  private initUnifiedChart() {
    if (!this.unifiedChartRef?.nativeElement) return;

    const ctx = this.unifiedChartRef.nativeElement.getContext('2d');
    if (!ctx) return;

    this.unifiedChart = new Chart(ctx, {
      type: 'bar',
      data: this.getUnifiedChartData(),
      options: this.getUnifiedChartOptions()
    });
  }

  private initDistributionChart() {
    if (!this.distributionChartRef?.nativeElement) return;

    const ctx = this.distributionChartRef.nativeElement.getContext('2d');
    if (!ctx) return;

    this.distributionChart = new Chart(ctx, {
      type: 'doughnut',
      data: this.distributionData,
      options: {
        responsive: true,
        maintainAspectRatio: false,
        cutout: '65%', // Agujero más grande
        plugins: {
          legend: {
            display: false
          }
        }
      }
    });
  }

  private updateUnifiedChart() {
    if (!this.unifiedChart) return;

    this.unifiedChart.data = this.getUnifiedChartData();
    this.unifiedChart.options = this.getUnifiedChartOptions();
    this.unifiedChart.update();
  }

  private updateDistributionChart() {
    if (!this.distributionChart) return;

    const data = this.currentChartType === 'hourly' ? this.distributionData : this.usersChartData;
    this.distributionChart.data = data;
    this.distributionChart.update();
  }

  private getUnifiedChartData() {
    const colors = this.chartDataType === 'consumption' ? this.ENERGY_COLORS : this.TIME_COLORS;
    let datasets: any[] = [];
    if (this.chartViewType === 'monthly') {
      const dataArray = this.chartDataType === 'consumption' ? this.ctmData.historialMensual : this.ctmData.activoPorDia;
      const media = dataArray.reduce((sum, val) => sum + val, 0) / dataArray.length;
      datasets = [
        {
          label: this.chartDataType === 'consumption' ? 'Consumo diario (kWh)' : 'Tiempo activo (min)',
          data: dataArray,
          backgroundColor: colors.background,
          borderColor: colors.border,
          borderWidth: 1,
          type: 'bar'
        },
        {
          label: 'Media',
          data: Array(dataArray.length).fill(media),
          borderColor: '#ff6384',
          backgroundColor: 'rgba(255, 99, 132, 0.1)',
          borderWidth: 2,
          type: 'line',
          fill: false,
          pointRadius: 0,
          pointHoverRadius: 4,
          borderDash: [5, 5]
        }
      ];
      return {
        labels: Array.from({length: dataArray.length}, (_, i) => (i + 1).toString()),
        datasets
      };
    } else {
      const dataArray = this.chartDataType === 'consumption' ? this.ctmData.historialAnual : this.ctmData.activoAnual;
      const media = dataArray.reduce((sum, val) => sum + val, 0) / dataArray.length;
      datasets = [
        {
          label: this.chartDataType === 'consumption' ? 'Consumo mensual (kWh)' : 'Tiempo activo (horas)',
          data: dataArray,
          backgroundColor: colors.background,
          borderColor: colors.border,
          borderWidth: 1,
          type: 'bar'
        },
        {
          label: 'Media',
          data: Array(dataArray.length).fill(media),
          borderColor: '#ff6384',
          backgroundColor: 'rgba(255, 99, 132, 0.1)',
          borderWidth: 2,
          type: 'line',
          fill: false,
          pointRadius: 0,
          pointHoverRadius: 4,
          borderDash: [5, 5]
        }
      ];
      return {
        labels: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
        datasets
      };
    }
  }

  private getUnifiedChartOptions() {
    return {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          display: true,
          position: 'top' as const,
          labels: {
            font: { size: 13 },
            boxWidth: 18,
            padding: 18,
            usePointStyle: true,
            pointStyle: 'circle'
          }
        }
      },
      scales: {
        x: {
          title: {
            display: true,
            text: this.chartViewType === 'monthly' ? 'Días del mes' : 'Meses del año',
            font: { size: 14 }
          }
        },
        y: {
          beginAtZero: true,
          title: {
            display: true,
            text: this.chartDataType === 'consumption' ? 'kWh' : (this.chartViewType === 'monthly' ? 'Minutos' : 'Horas'),
            font: { size: 14 }
          }
        }
      }
    };
  }

  getTotalTime(): number {
    return this.usersData.reduce((total, user) => total + user.time, 0);
  }

  getTotalConsumption(): number {
    return this.usersData.reduce((total, user) => total + user.consumption, 0);
  }

  getTotalCost(): number {
    return this.usersData.reduce((total, user) => total + user.cost, 0);
  }

  getMonthlyRevenue(): number {
    const totalTime = this.getTotalTime();
    return totalTime * this.pricePerHour;
  }

  // Métodos para obtener datos del CTM
  getCtmStatus(): string {
    return this.ctmData?.activo ? 'ON' : 'OFF';
  }

  getCtmStatusIcon(): string {
    return this.ctmData?.activo ? 'fa-play' : 'fa-pause';
  }

  getCtmStatusColor(): string {
    return this.ctmData?.activo ? 'green' : 'red';
  }

  getCtmConnection(): string {
    return this.ctmData?.online ? 'Conectado' : 'Desconectado';
  }

  getCtmConnectionIcon(): string {
    return this.ctmData?.online ? 'fa-wifi' : 'fa-wifi-slash';
  }

  getCtmConnectionColor(): string {
    return this.ctmData?.online ? 'green' : 'red';
  }

  getCtmMonthlyConsumption(): number {
    if (!this.ctmData?.historialMensual || this.ctmData.historialMensual.length === 0) {
      return 0;
    }
    const totalMonthly = this.ctmData.historialMensual.reduce((sum, daily) => sum + daily, 0);
    return totalMonthly;
  }

  getCtmEstimatedCost(): number {
    const consumption = this.getCtmMonthlyConsumption();
    return parseFloat((consumption * this.priceKwh).toFixed(2));
  }

  getCtmEnergyTrend(): number {
    if (!this.ctmData?.historialAnual || this.ctmData.historialAnual.length < 2) {
      return 0;
    }
    const currentMonth = this.ctmData.historialAnual[this.ctmData.historialAnual.length - 1];
    const previousMonth = this.ctmData.historialAnual[this.ctmData.historialAnual.length - 2];

    if (previousMonth === 0) return 0;

    const change = ((currentMonth - previousMonth) / previousMonth) * 100;
    return parseFloat(change.toFixed(1));
  }

  getCtmTimeTrend(): number {
    if (!this.ctmData?.activoPorDia || this.ctmData.activoPorDia.length < 2) {
      return 0;
    }

    const currentMonthTime = this.ctmData.activoPorDia.reduce((sum, time) => sum + time, 0);
    const previousMonthTime = currentMonthTime * 0.9; // Temporal

    if (previousMonthTime === 0) return 0;

    const change = ((currentMonthTime - previousMonthTime) / previousMonthTime) * 100;
    return parseFloat(change.toFixed(1));
  }

  getCtmActiveTimeFormatted(): string {
    const totalMinutes = this.ctmData?.tiempoActivo || 0;
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    return `${hours}h ${minutes}m`;
  }

  getCtmTotalUsageTime(): string {
    if (!this.ctmData) {
      return '0h 0m';
    }

    const activoPorDia = this.ctmData?.activoPorDia || [];

    if (activoPorDia.length === 0) {
      return '0h 0m';
    }

    const totalMinutosMes = activoPorDia.reduce((sum, minutes) => sum + minutes, 0);
    const totalMinutosHistorico = totalMinutosMes * 12; // Simulamos 12 meses

    const dias = Math.floor(totalMinutosHistorico / 1440); // 1440 minutos = 1 día
    const horasRestantes = Math.floor((totalMinutosHistorico % 1440) / 60);

    if (dias > 0) {
      return `${dias}d ${horasRestantes}h`;
    } else {
      const horas = Math.floor(totalMinutosHistorico / 60);
      const minutos = totalMinutosHistorico % 60;
      return `${horas}h ${minutos}m`;
    }
  }

  getCtmCurrentUser(): string {
    if (!this.ctmData?.activo) {
      return 'Sin sesión';
    }
    return this.usersData && this.usersData.length > 0
      ? this.usersData[0].name
      : 'Usuario activo';
  }

  getCtmRemainingTime(): string {
    if (!this.ctmData?.activo) {
      return '--';
    }
    return '1h 15m';
  }
}
